import React from 'react'
import { Collapse } from 'reactstrap'
import {
  AccordionHeader,
  Content,
  AccordionContainer
} from './AccordionStyledComponents'
import PropTypes from 'prop-types'

class Accordion extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      collapse: this.props.openIndex || 0,
      thin: this.props.thin || false
    }
  }

  componentDidUpdate (prevProps) {
    const { openIndex } = this.props
    if (openIndex && openIndex !== prevProps.openIndex) {
      this.setState({ collapse: openIndex })
    }
  }

  toggle = index => {
    this.setState({
      collapse: this.state.collapse === Number(index) ? null : Number(index)
    })
  }

  render () {
    const items = this.props.items
    const { collapse } = this.state

    const list = items.map((item, index) => {
      return (
        <div key={index} id={item.id || 'accordion'}>
          <AccordionHeader
            selected={collapse === index}
            onClick={() => this.toggle(index)}
            data-event={index}
          >
            {collapse === index ? '-' : '+'}{' '}
            {typeof item.header === 'string'
              ? item.header.toUpperCase()
              : item.header}
          </AccordionHeader>
          <Collapse isOpen={collapse === index}>
            <Content>{item.content}</Content>
          </Collapse>
        </div>
      )
    })

    return (
      <AccordionContainer thin={this.state.thin}>{list}</AccordionContainer>
    )
  }
}

Accordion.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  thin: PropTypes.bool,
  openIndex: PropTypes.number
}

export default Accordion
